var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "line-wrapper"
  }, [_c("a-row", {
    staticClass: "line-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "时间管理统计图",
      hoverable: true,
      bordered: false
    }
  }, [_c("only-line", {
    staticClass: "chart-line"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "气温统计图",
      hoverable: true,
      bordered: false
    }
  }, [_c("more-line", {
    staticClass: "chart-line"
  })], 1)], 1)], 1), _c("a-row", {
    staticClass: "line-list",
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "LOL经济与伤害对比图",
      hoverable: true,
      bordered: false
    }
  }, [_c("stack-line", {
    staticClass: "chart-line"
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: "LOL直播人气值",
      hoverable: true,
      bordered: false
    }
  }, [_c("other-line", {
    staticClass: "chart-line"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };